type BadgeNavigator = Navigator & {
  setAppBadge?: (contents?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

const normalizeBadgeCount = (count: number): number => {
  if (!Number.isFinite(count)) return 0;
  return Math.max(0, Math.floor(count));
};

export const syncAppBadge = (count: number): void => {
  if (typeof navigator === 'undefined') return;

  const badgeNavigator = navigator as BadgeNavigator;
  const normalized = normalizeBadgeCount(count);

  if (normalized > 0 && typeof badgeNavigator.setAppBadge === 'function') {
    void badgeNavigator.setAppBadge(normalized).catch(() => undefined);
    return;
  }

  if (normalized === 0 && typeof badgeNavigator.clearAppBadge === 'function') {
    void badgeNavigator.clearAppBadge().catch(() => undefined);
  }
};
